var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportBankTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M115.8 53.8V35.9c0-1.7 1.4-3 3-3h47.3l15.7 14.3V114c0 1.7-1.4 3-3 3h-27.5M181.8 47.2h-15.6M166.2 47.2V32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M151.3 105.1v34.6H17.9V53.8h133.4v29.5M76.6 141v8.5c-.1 9.9-10.5 9.6-10.5 9.6H41.8v6.4h85.9l-.1-6.4h-24.3s-10.5.4-10.5-9.6V141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M139.8 90.3v7.8H160v9.5l13.4-14.1-13.8-12.9v9.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M105.4 82.1v35.7M65 82.1v35.7M57 82.1h55.5L84.9 64.8zM60.4 117.8h49.8v5.6H60.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M89.6 91.8c-10.1-2.9-10.1 7.6-3.7 7.5 6.2-.1 7 9.9-4.1 6.8M85.9 89.6v.6M85.9 107.9v.6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportBankTransactions);
export default __webpack_public_path__ + "static/media/exportBankTransactions.178621a7f63a259dcc5bb42beec385b8.svg";
export { ForwardRef as ReactComponent };